import React from 'react';
import { Tooltip, Select } from 'antd';
import moment from 'moment';
import { Base64 } from 'js-base64';
import { documentsConstants } from '../containers/Documents/constants/documents.constants';
import { informationsConstants } from '../containers/Informations/informations.constants';
import getName from './getName';

export function filterPNumber(value) {
    if (/^(\d+)$/.test(value)) {
      return Number(value)
    } else {
      return NaN
    }
  }
export function parseToken(token) {
    if (!token) return null
    const b64Url = token.split('.')[1];
    const b64 = b64Url.replace('-', '+').replace('_', '/');
    const userInfo = JSON.parse(Base64.decode(b64));
    for(const key in userInfo){
        if (userInfo[key] === 'False' || userInfo[key] === 'false' ) userInfo[key] = false 
        else if(userInfo[key] === 'True' || userInfo[key] === 'true' ) userInfo[key] = true 
    }
    //userInfo['CanChangeDescription'] = true
    return userInfo;
};

export function parseUser() {
    const user = JSON.parse(localStorage.getItem('user'));
    return user && parseToken(user.access)
};

export const dspxGetWorkerChildrens = (
  workers,
  over = 23,
  withValue = false,
  specInLabel = false
) => {
  if (!Array.isArray(workers)) return [];

  return workers.map((worker) => {
    const name = getName(worker);
    const speciality = worker.specialityName || worker.speciality;

    let option = name;

    if (speciality) {
      option = (
        <div>
          <div
            style={{
              lineHeight: 1.1,
              fontSize: 10,
              fontWeight: 700,
              overflow: 'hidden',
              textOverflow: 'ellipsis',
            }}
          >
            {speciality}
          </div>
          <div 
            style={{
              whiteSpace: 'nowrap',
              overflow: 'hidden',
              textOverflow: 'ellipsis'
            }}
          >
            {name}
          </div>
        </div>
      );
    }

    if (name.length > over || speciality?.length > 23) {
      option = (
        <Tooltip title={option} mouseEnterDelay={1}>
          {option}
        </Tooltip>
      );
    }

    const label =
      specInLabel && speciality ? (
        <div>
          <div
            style={{
              lineHeight: 1,
              fontSize: 10,
              whiteSpace: 'nowrap',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              fontStyle: 'italic',
            }}
          >
            {speciality}
          </div>
          <div
            style={{
              lineHeight: 1,
              fontSize: 12,
              whiteSpace: 'nowrap',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              fontWeight: '500',
            }}
          >
            {name}
          </div>
        </div>
      ) : (
        name
      );
    const optionProps = {
      key: worker.id,
      searchtext: [name, speciality].filter(Boolean).join(' '),
      label: label,
      ...(withValue ? {value: worker.id} : {})
    }

    return (
      <Select.Option {...optionProps}>
        {option}
      </Select.Option>
    );
  });
};

export const dspxGetChildrens = (cr, over, withData, getValue) =>
  Array.isArray(cr) &&
  cr.map((el) => {
        const v = el.fullName || el.description || el.name
        let t = v
        if(el.city) {
            t = <div>
              <div style={{lineHeight:0.5, color:'#888', fontSize:10, fontWeight:500}} >{el.city}</div>
              <div>{v}</div>
            </div>
        }
        const ov = over || 23
        if(v.length > ov) {
            t = <Tooltip title={v} mouseEnterDelay={1}>{t}</Tooltip>
        }

        const props = {};

        if (withData) {
          props.data = el;
        }
     
        if (typeof getValue === 'function') {
          props.value = getValue(el, cr);
        }

         return (
          <Select.Option
            key={el.id}
            searchtext={v}
            label={v}
            {...props}
          >
            {t}
          </Select.Option>
         )
    });

  const ALL_HOUSE_TYPE_ID = 1;
  const PORCH_TYPE_ID = 2;
  const exceptionTypeSet = new Set([ALL_HOUSE_TYPE_ID, PORCH_TYPE_ID]);
  export const getRoomNameAndSynonym = (word) => {
    const openingBracketIndex = word ? word.indexOf('(') : -1;
    const closingBracketIndex = word ? word?.indexOf(')') : -1;
  
    if (openingBracketIndex !== -1 && closingBracketIndex !== -1) {
      const textBeforeBrackets = word.substring(0, openingBracketIndex).trim();
      const textInsideBrackets = word
        .substring(openingBracketIndex, closingBracketIndex + 1)
        .trim();
      return [textBeforeBrackets, textInsideBrackets];
    } else {
      return [word || ''];
    }
  };

export const getRoomOptionCreator =
  ({ over = 11 } = {}) =>
  (room) => {
    const type = !exceptionTypeSet.has(room.typeId)
      ? room.typeShortName?.trim()
      : '';
    const [name, synonym] = getRoomNameAndSynonym(room.name?.trim());
    const content = [name, type, synonym].filter(Boolean).join(' ');

    return (
      <Select.Option
        key={room.id}
        label={content}
        searchtext={content}
      >
        <Tooltip
          title={content.length > over ? content : ''}
          mouseEnterDelay={1}
        >
          {content}
        </Tooltip>
      </Select.Option>
    );
  };

export const dspxGetRoomOptions = (rooms, over = 11, meta) => {
  if (Array.isArray(rooms)) {
    const createOption = getRoomOptionCreator({ over });
    return rooms.map(createOption);
  }
}

	export const dspxGetDocTypesChildrens = (cr, withoutImg) => Array.isArray(cr)
    && cr.map(el => {					
        const v = el.fullName || el.description || el.name
        return <Select.Option key={el.id} searchtext={v} label={v} value={el.id}>
                {!withoutImg && <span role="img" aria-label={v} style={{marginRight:5}}>
                    {documentsConstants.docTypeIcon(el.id,25)}
                </span>}
                {v}</Select.Option> 
    });

    export const dspxGetInfoTypesChildrens = cr => Array.isArray(cr)
    && cr.map(el => {					
        const v = el.name
        return <Select.Option key={el.id} searchtext={v} label={v}>
                <span role="img" aria-label={v} style={{marginRight:5}}>
                    {informationsConstants.informationTypeIcon(el.id,25)}
                </span>
                {v}</Select.Option> 
    });

    export const dspxGetChildrensContractor = (cr,over) => Array.isArray(cr)
    && cr.map(el => {
        const s = el.inn+' '+el.name+' '+(el.directorFio ? el.directorFio : '')
        const v = <div><span style={{color:'#1aa0d6', fontSize: '12px', marginRight: 8}}>{el.inn}</span>
        <span>{el.name}</span>{el.directorFio && <span style={{fontSize:'11px', marginLeft: 8, color: '#19867d', fontStyle:'italic'}}>( {el.directorFio} )</span> }</div>
        const ov = over || 23
        return s.length > ov
            ? <Select.Option key={el.id} searchtext={s}>
                <Tooltip title={s} mouseEnterDelay={1}>{v}</Tooltip>
            </Select.Option> : <Select.Option key={el.id} searchtext={s}>{v}</Select.Option>
    });

    export const dspxGetChildrensDocumentContractor = (cr, inn, man, over) => Array.isArray(cr)
    && cr.map(el => {
        const s = el.inn+' '+el.name+' '+(el.director ? el.director : '')
        const v = <div>{inn && <span style={{color:'#1aa0d6', fontSize: '12px', marginRight: 8}}>{el.inn}</span>}
        <span>{el.name}</span>{el.director && man && <span style={{fontSize:'11px', marginLeft: 8, color: '#19867d', fontStyle:'italic'}}>( {el.director} )</span> }</div>
        const ov = over || 23
        return s.length > ov
            ? <Select.Option key={el.id} searchtext={s}>
                <Tooltip title={s} mouseEnterDelay={1}>{v}</Tooltip>
            </Select.Option> : <Select.Option key={el.id} searchtext={s}>{v}</Select.Option>
    });

export const dspxDiffSeconds = (a, b) =>
    moment(a, "YYYY-MM-DD HH:mm:ss").diff(moment(b, "YYYY-MM-DD HH:mm:ss"), 'seconds');

export const dspxDiffDays = (a, b) =>
    (a ? moment(a) : moment()).diff(moment(b), 'days');

export const declOfNum = (number, titles) => {
    const cases = [2, 0, 1, 1, 1, 2];
    return titles[(number % 100 > 4 && number % 100 < 20) ? 2 : cases[(number % 10 < 5) ? number % 10 : 5]];
}
